import React, { useEffect } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getAllFavoriteItems } from '@/redux/modules/favorites/favorites.selectors';
import { getItemSummariesForCatalog, getItemSummaryIndex } from '@/redux/modules/item/summary/itemSummary.selectors';

type Props = {
    catalogId: number;
    itemId: number;
};

export const useCalculateNextFavorite = ({ catalogId, itemId }: Props) => {
    const favoriteItems = useAppSelector((state) => getAllFavoriteItems(state));
    const items = useAppSelector((state) => getItemSummariesForCatalog(state, catalogId));
    const index = useAppSelector((state) => getItemSummaryIndex(state, itemId));

    const [nextFavorite, setNextFavorite] = React.useState(0);

    useEffect(() => {
        if (!favoriteItems.length) {
            setNextFavorite(0);
            return;
        }

        const itemWithFavorite = items.find(
            (item) => item.index > index && favoriteItems.find((favoriteItemId) => favoriteItemId === item.itemId)
        );

        if (itemWithFavorite) {
            setNextFavorite(itemWithFavorite.index - index);
        } else {
            setNextFavorite(0);
        }
    }, [favoriteItems, index, items]);

    return nextFavorite;
};
